import { xml2js } from "xml-js";

export class GpxReadError extends Error {
  constructor() {
    super("Invalid GPX file");
    this.name = "GpxReadError";
  }
}

const asArray = (value) =>
  value == null ? [] : Array.isArray(value) ? value : [value];

export const parseGpxTrack = (content) => {
  try {
    const document = new DOMParser().parseFromString(content, "application/xml");
    if (
      document.getElementsByTagName("parsererror").length > 0 ||
      document.documentElement?.localName !== "gpx"
    ) {
      throw new GpxReadError();
    }
    const gpx = xml2js(content, { compact: true }).gpx;
    return asArray(gpx?.trk).flatMap((track) =>
      asArray(track?.trkseg).flatMap((segment) =>
        asArray(segment?.trkpt).flatMap((point) => {
          const attributes = point?._attributes;
          if (!attributes?.lat?.trim() || !attributes?.lon?.trim()) {
            return [];
          }
          const lat = Number(attributes.lat);
          const lng = Number(attributes.lon);
          return Number.isFinite(lat) && Number.isFinite(lng) &&
            Math.abs(lat) <= 90 && Math.abs(lng) <= 180
            ? [{ lat, lng }]
            : [];
        })
      )
    );
  } catch (error) {
    throw new GpxReadError();
  }
};

export const resolveGpxImportMode = (result) =>
  result?.isConfirmed
    ? "complementary"
    : result?.isDenied
    ? "replace"
    : "cancel";

export const isExplicitConfirmation = (result) => result?.isConfirmed === true;

export const hasExistingGpxTrack = (track, polyline, additionalTracks) =>
  (Array.isArray(track) && track.length > 0) ||
  Boolean(polyline) ||
  (Array.isArray(additionalTracks) && additionalTracks.length > 0);

export const selectImportedTracksPayload = (current, lastSaved) => {
  if (current === lastSaved || (!current?.length && !lastSaved?.length)) {
    return undefined;
  }
  return (current || []).map((track) => ({
    ...(track.name ? { name: track.name } : {}),
    points: track.points,
  }));
};